module.exports = __webpack_public_path__ + "img/snack.a34229fb.png";